import React, { useState, useEffect } from 'react'
import { TextField, MenuItem, Box, Chip, Grid } from '@mui/material'
import { Warehouse } from '../../../interfaces'

interface WarehouseMultiSelectProps {
  warehouses: Warehouse[]
  selectedItems: number[] // array de IDs seleccionados
  setSelectedItems: (newSelected: number[]) => void
  required?: boolean
}

const WarehouseMultiSelect: React.FC<WarehouseMultiSelectProps> = ({
  warehouses,
  selectedItems,
  setSelectedItems,
  required = false
}) => {
  const [hasError, setHasError] = useState(false)
  const [selected, setSelected] = useState(-1)

  useEffect(() => {
    if (required && selectedItems.length === 0) {
      setHasError(true)
    } else {
      setHasError(false)
    }
  }, [selectedItems, required])

  const handleInputChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const value = event.target.value as number
    setSelected(-1)
    if (value > 0 && !selectedItems.includes(value)) {
      setSelectedItems([...selectedItems, value])
    }
  }

  const deleteItem = (id: number) => {
    setSelectedItems(selectedItems.filter((itemId) => itemId !== id))
  }

  return (
    <Grid container spacing={0} direction='column'>
      <Grid item xs={12}>
        <TextField
          select
          value={selected}
          onChange={handleInputChange}
          fullWidth
          style={{ maxWidth: 300 }} // 🔹 evita que se agrande
          error={hasError}
          helperText={hasError ? 'Seleccionar al menos un Almacén' : undefined}
          variant='outlined'
          size='small'
        >
          <MenuItem key={-1} value={-1} disabled>
            Seleccionar Almacén...
          </MenuItem>

          {warehouses
            .filter((w) => !selectedItems.includes(w.id))
            .map((w) => (
              <MenuItem key={w.id} value={w.id}>
                {w.warehouseName}
              </MenuItem>
            ))}
        </TextField>
      </Grid>

      <Grid item xs={12}>
        <Box display='flex' flexWrap='wrap' mt={0.75} style={{ gap: 5 }}>
          {selectedItems.map((id) => {
            const warehouse = warehouses.find((w) => w.id === id)
            return (
              <Chip
                key={id}
                label={warehouse?.warehouseName || id}
                onDelete={() => deleteItem(id)}
              />
            )
          })}
        </Box>
      </Grid>
    </Grid>
  )
}

export default WarehouseMultiSelect
